<template>
    <div v-if="!loading" class="customer-order-wrapper">
        <div class="d-flex justify-content-between align-items-end customer-order-header">
            <div class="row p-0 m-0">
                <h2 class="mb-0">
                    <div>
                        <div>Worksheet</div>
                        <div v-if="this.orderNumber" class="header-order-id">Order {{this.orderNumber}}</div>
                    </div>
                </h2>
                <input :disabled="!uncommitted || isReadOnly" class="worksheet-input" @change="formChanged" placeholder="Worksheet Name" label="Worksheet Name" v-model="worksheetName"/> 
            </div>
            
            <div><span class="font-weight-bold" :class="orderStatus">{{orderStatus}}</span></div>
        </div>

        <hr>
        <form @change="formChanged" class="customer-order">
            <div class="d-flex justify-content-between">
                <div class="row top-level-order-btns">
                        <div class="btn col btn-secondary ml-2 mr-2" @click="$router.back()"><i class="fas fa-arrow-left text-primary mr-2"></i>Back</div>
                        <div class="btn col btn-secondary ml-2 mr-2" @click="newOrderHasBeenRequested"><i class="fa fa-plus text-primary mr-2"></i>New Order</div>
                        <div v-if="committed && !isReadOnly"  @click="submitToOrderLink" class="btn col btn-secondary ml-2 mr-2 text-warning"><i class="fa fa-bolt mr-2"></i>OrderLink</div>
                        <div v-if="uncommitted && orderHasId && !isReadOnly" @click="toggleCommitModal" class="btn col btn-secondary ml-2 mr-2 text-success"><i class="fa fa-check mr-2"></i>Commit</div>
                        
                        <!-- <div class="btn btn-secondary ml-2 mr-3">Generate Form</div> -->
                    <!-- </div>
                    <div class="col-6 row justify-content-flex-end"> -->
                        <div v-if="reportTypes.length > 0 && orderHasId" class="dropdown col m-0 p-0 btn" >
                            <div class="btn btn-secondary dropdown-toggle" :data-toggle="reportTypes.length > 0 ? 'dropdown' : ''">
                                Generate Forms
                                <span class="caret"></span>
                            </div>
                            <ul  class="dropdown-menu">
                                <li v-for="type in reportTypes" :key="type.Id" class='pointer form-item' @click="generateReport(type)">{{type.DisplayName}}</li>
                            </ul>
                        </div>
                        <div class="col d-flex  ml-2 mr-2" :style="{minWidth: '180px'}">
                            <div class="m-0 p-0 row align-items-center">
                                <div class="mr-1 font-weight-bolder text-primary" >Detail View</div>
                                <label class="switch">
                                    <input v-model="detailView" type="checkbox">
                                    <span class="slider round"></span>
                                </label>
                                <!-- <Toggle-Switch />  -->
                            </div>
                        </div>
                        <div class="col justify-self-right ml-2 mr-2" :style="{minWidth: '140px'}">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">Menu
                                <span class="caret"></span></button>
                                <ul class="dropdown-menu">
                                    <li><label class='pointer'>Import<input type="file" @change="importFileSelected" style="position: fixed; top: -100em"></label></li>
                                    <li class='pointer' v-if="orderHasId && committed && currentUserSalesAdminOrMgr" @click="toggleUncommitModal">Uncommit Order</li>
                                    <li class='pointer' @click="cloneOrder">Duplicate Order</li>
                                    <li class='pointer' v-if="orderHasId && !isReadOnly" @click="toggleDeleteModal">Delete Order</li>
                                </ul>
                            </div>
                        </div>
                    
                </div>
            </div>

            <hr>

            <div class="row mb-4">
                <div class="col-4">
                    <AdvancedCustomerSearch label="Customer" :disabled="true" :readOnly="isReadOnly || !uncommitted" v-model="currentCustomer" @change="updateCustomerInfo" placeholder="Search..." class="mb-2" />
                    <div v-if="$v.currentCustomer.Id && $v.currentCustomer.Id.$error && $v.currentCustomer.Id.$dirty ">
                        <div class="validation-error" >Customer is Required</div>
                    </div>
                    <AdvancedOrderSearch :key="currentCustomer.Id" label="Order" :disabled="true" :readOnly="isReadOnly || !uncommitted"  :currentCustomerId="currentCustomer.Id" v-model="worksheetName" @change="updateOrderInfo" placeholder="Search..." class="mb-2" />
                    <!-- <BasicTextInput label="Order Number" :disabled="!uncommitted || isReadOnly" placeholder="ex: 12345" class="mb-2" /> -->
                    
                </div>
                <div class="col-4">
                    <DatePicker label="Installation Date" :readOnly="isReadOnly || !uncommitted" v-model="installationDate" @change="formChanged('installDate')" class="mb-2" />
                    <div v-if="$v.installationDate && $v.installationDate.$error && $v.installationDate.$dirty ">
                        <div class="validation-error" >Please select an installation date before committing</div>
                    </div>
                    <DatePicker label="Expiration Date" :readOnly="isReadOnly || !uncommitted" v-model="expirationDate"  @change="formChanged('expirDatae')" class="mb-2" />
                </div>
                <div class="col-4">
                    <div class="date-display">
                        <div class="date-display__wrapper">
                            <div class="date-display__title">Creation Date: </div>
                            <div class="data-display__value">{{ creationDate }}</div>
                        </div>
                        <div class="date-display__wrapper">
                            <div class="date-display__title">Revision Date: </div>
                            <div class="data-display__value">{{ revisionDate }}</div>
                        </div>
                    </div>
                </div>  
            </div>

            <div class="row">
                <div class="col-12">
                    <div class='customer-info-header-wrapper'>
                        <h4>Customer Information</h4>
                        <p class="show-details-toggle" @click="showCustomerInfo = !showCustomerInfo">{{showCustomerInfo ? 'Hide' : 'Show'}}</p>
                    </div>
                    

                    <hr>
                </div>
            </div>

            <div v-if="showCustomerInfo" class="row mb-4">
                <div class="col-6">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Billing Information</h5>
                            <hr>
                        </div>
                        <div class="card-body">
                            <BasicTextInput label="Company" :disabled="!uncommitted || isReadOnly" placeholder="Ex: Acme, Inc." v-model="billingAddress.Name" class="mb-2" />
                            <div class="row mb-2">
                                <div class="col-8">
                                    <BasicTextInput label="Address" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.Line1" placeholder="Enter Address Line 1" />
                                </div>
                                <div class="col-4">
                                    <BasicTextInput label="Suite" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.Line2" placeholder="Enter Address Line 2" />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <BasicTextInput label="City" :disabled="!uncommitted || isReadOnly" v-model="billingAddress.City"  placeholder="Enter City" />
                                </div>
                                <div class="col">
                                    <StateSelect  :disabled="!uncommitted || isReadOnly" v-model="billingAddress.StateId" label="State"   />
                                </div>
                                <div class="col">
                                    <ZipCodeInput  :disabled="!uncommitted || isReadOnly"  label="Zip"   v-model="billingAddress.ZipCode"  placeholder="Enter Zip Code" />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-6">
                                    <PhoneNumberInput v-model="billingAddress.PhoneNumber" :disabled="!uncommitted || isReadOnly" label="Phone"></PhoneNumberInput>
                                </div>
                                <div class="col-6">
                                    <PhoneNumberInput v-model="billingAddress.FaxNumber" :disabled="!uncommitted || isReadOnly" label="Fax"></PhoneNumberInput>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <BasicTextInput v-model="billingAddress.Contact" :disabled="!uncommitted || isReadOnly" label="Contact" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Shipping Information</h5>
                            <hr>
                        </div>
                        <div class="card-body">
                            <ShipToDropdown :key="shippingAddress.LastUsedCustomerAddressId" label="Ship to" :disabled="!uncommitted || isReadOnly" :currentCustomer="currentCustomer" :items="currentCustomer.Addresses" @change="updateShippingInfo" v-model="shippingAddress.LastUsedCustomerAddressId" class="mb-2"/>
                            <BasicTextInput v-if="!shippingAddress.LastUsedCustomerAddressId" label="Name" placeholder="Ex: Acme, Inc." :disabled="!uncommitted || isReadOnly" v-model="shippingAddress.Name"  />
                            <div class="row mb-2">
                                <div class="col-8">
                                    <BasicTextInput label="Address" v-model="shippingAddress.Line1" :disabled="!uncommitted || isReadOnly" placeholder="Enter Address Line 1" />
                                </div>
                                <div class="col-4">
                                    <BasicTextInput label="Suite"  v-model="shippingAddress.Line2" :disabled="!uncommitted || isReadOnly" placeholder="Enter Address Line 2" />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <BasicTextInput label="City"   v-model="shippingAddress.City" :disabled="!uncommitted || isReadOnly" placeholder="Enter City" />
                                </div>
                                <div class="col">
                                    <StateSelect    label="State"   v-model="shippingAddress.StateId" :disabled="!uncommitted || isReadOnly"/>
                                </div>
                                <div class="col">
                                    <ZipCodeInput   label="Zip"   v-model="shippingAddress.ZipCode"  :disabled="!uncommitted || isReadOnly" placeholder="Enter Zip Code" />
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-6">
                                    <PhoneNumberInput label="Phone" v-model="shippingAddress.PhoneNumber" :disabled="!uncommitted || isReadOnly"></PhoneNumberInput>
                                </div>
                                <div class="col-6">
                                    <PhoneNumberInput label="Fax" v-model="shippingAddress.FaxNumber" :disabled="!uncommitted || isReadOnly"></PhoneNumberInput>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <BasicTextInput label="Contact" v-model="shippingAddress.Contact" :disabled="!uncommitted || isReadOnly"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <h4>Order Lines</h4>
                    <hr>
                    <div :key="OrderGridUpdateKey" class="col grid-wrapper">
                        <CustomerOrderGrid 
                            v-for="(bundle, index) in bundles"
                            :key="bundle.OrderLineGroupId"
                            :readOnly="!uncommitted || isReadOnly"
                            :dataSource="orderLines" 
                            :OrderLineGroupName="bundle.OrderLineGroupName"
                            :OrderLineGroupId="bundle.OrderLineGroupId"
                            :PrintOptionId="bundle.PrintOptionId"
                            :printOptions="printOptions"
                            :gridIndex="index"
                            :roundToDollar="OrderSalesSettings.RoundToNearestDollar"
                            :showColumnLines="true"
                            :defaultGP="defaultGP"
                            @updateData="updateOrderLines"
                            @createNewBundle="createNewBundle"
                            @deleteBundle="deleteBundle"
                            @editBundle="editBundle"
                            @deleteBundleAndKeepOrderLines="deleteBundleAndKeepOrderLines"
                            @itemHasBeenAdded="formChanged"
                            :detailView="detailView"
                            :totalsSummary="totalsSummary[index]"
                            @updateTotalsValues="updateTotalsValues"
                            @updateOrderLineNumbers="updateOrderLineNumbers"
                            @addProductFromSmartCatalog="addProductFromSmartCatalog"
                            @addProductsFromConfigurator="addProductsFromConfigurator"
                            @copyOrderLines="copyOrderLines"
                        />
                    </div>
                </div>
            </div>
            <div  class="row mb-4"></div>
            <hr>
            <div class="lower-section">
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">Order Representative</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <SalesRepSelect v-model="ownerSalesRepId"  :disabled="!uncommitted || isReadOnly" class="mb-2" label="Order Owner"
                            :salesReps="salesReps" :key="ownerSalesRepId"/>
                            <div v-if="$v.ownerSalesRepId && $v.ownerSalesRepId.$error && $v.ownerSalesRepId.$dirty ">
                                <div class="validation-error" >Please assign an owner rep</div>
                            </div>
                        <ColleagueSelect v-model="AdditionalRepCode" :disabled="!uncommitted || isReadOnly" class="mb-2" label="Additional Rep"
                            :colleagues="colleagues" :key="AdditionalRepCode"/>                          
                        <ColleagueSelect v-model="EquipmentRepCode" :disabled="!uncommitted || isReadOnly" class="mb-2" label="Sales Rep"
                            :colleagues="colleagues" :key="EquipmentRepCode"/>                          
                        <BasicTextInput :disabled="true" v-model="transferredRep" class="mb-2" label="Transferred From"
                            />                        
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h5 class="card-title">Payment Information</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <DatePicker :readOnly="isReadOnly || !uncommitted" @change="formChanged" v-model="paymentDueOn" label="Payment Due" />
                        <!-- <BasicDropdown label="Equipment Type" v-model="equipmentType" :items="[]"/> -->
                    </div>
                </div>
                <div class="card summary">
                    <div class="card-header">
                        <h5 class="card-title">Order Summary</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <CurrencyInput label="Subtotal"     v-model="totals.subtotal" :disabled="true"  placeholder="" class="mb-2" />
                        <CurrencyInput label="Freight"     @change="freightChanged" v-model="totals.freight"   :disabled="!uncommitted || isReadOnly" placeholder="" class="mb-2" />
                        <div class="row mb-2">
                            <div class="col-6"><PercentInput @change="setTotals"  :disabled="!uncommitted || isReadOnly" v-model="totals.salesTax" label="Sales Tax"  /></div>
                            <div class="col-6">
                                <CurrencyInput :disabled="true" v-model="totals.salesTaxAmount" placeholder="" />
                            </div>
                        </div>
                        <CurrencyInput label="Total"        v-model="totals.total"          :disabled="true"  placeholder="" class="mb-2" />
                        <CurrencyInput label="Down Payment" v-model="totals.downPayment"   @change="downPaymentChanged"  :disabled="!uncommitted || isReadOnly" placeholder="" class="mb-2" />
                        <CurrencyInput label="Balance Due"  v-model="totals.balanceDue"     :disabled="true"  placeholder="" class="mb-2" />
                        <div v-if="detailView" class="p-0 m-0">
                            <CurrencyInput label="Discount"     v-model="totals.discount"   :disabled="true" placeholder="" class="mb-2" />
                            <CurrencyInput label="Dealer Cost"  v-model="totals.dealerCost" :disabled="true" placeholder="" class="mb-2" />
                            <CurrencyInput label="Profit"       v-model="totals.profit"     :disabled="true" placeholder="" class="mb-2" />
                            <PercentInput  label="Actual GP"    v-model="totals.actualGP"   :disabled="true" placeholder="" class="mb-2" />
                        </div>
                    </div>
                </div>
                <div class="card" :class="detailView ? '' : 'hide-confidential'">
                    <div class="card-header">
                        <h5 class="card-title">General Notes</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                       <TextAreaInput  :disabled="!uncommitted || isReadOnly" v-model="generalNotes"/>
                    </div>
                </div>
                <div v-if="detailView" class="card">
                    <div class="card-header">
                        <h5 class="card-title">Confidential Notes</h5>
                        <hr>
                    </div>
                    <div class="card-body">
                        <TextAreaInput :disabled="!uncommitted || isReadOnly" v-model="confidentialNotes" />
                    </div>
                </div>
            </div>

            <div class="row mt-4 mb-5">
                <div class="col-4 offset-8 lower-level-order-btns__right">
                    <!-- <button class="btn btn-lg btn-secondary">Cancel</button> -->
                    <div class="btn btn-lg btn-primary" v-if="uncommitted && !isReadOnly" @click="saveOrder" >Save</div>

                </div>
            </div>

        </form>
        <Modal ref="deleteOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Are you sure you would like to delete this order?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleDeleteModal">Cancel</button>
                    <button @click="deleteOrder" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </Modal>
        <Modal ref="commitOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Once you commit your order, no changes can be made. Please confirm you wish to commit the order.</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleCommitModal">Cancel</button>
                    <button @click="saveAndCommitOrder" class="btn btn-primary">Commit</button>
                </div>
            </div>
        </Modal>
        <Modal ref="newOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Would you like to save the current order?</p> 
                <!-- <p class="mt-0 ">to delete this order?</p> -->
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="createNewOrder">No do not save</button>
                    <button @click="saveAndCreateNewOrder" class="btn btn-primary">Yes</button>
                </div>
            </div>
        </Modal>
        <Modal ref="uncommitOrderModal">
            <div class="card modal-wrapper p-4">
                <p class="modal-text">Are you sure you would like to uncommit this order?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleUncommitModal">Cancel</button>
                    <button @click="uncommitOrder" class="btn btn-primary">Uncommit</button>
                </div>
            </div>
        </Modal>  
        <!-- <Modal ref="routeGuardModal">
            <div class="card modal-wrapper p-4">
                <p class="m-0">Would you like to save you changes</p> 
                <p class="mt-0 ">before leaving the page?</p>
                <div class="btn-wrapper center">
                    <button class="btn btn-secondary" @click="toggleRouteGuardModal">Cancel</button>
                    <button @click="uncommitOrder" class="btn btn-primary">No, delete changes</button>
                    <button @click="uncommitOrder" class="btn btn-primary">Yes, save changes</button>
                </div>
            </div>
        </Modal>       -->
    </div>
</template>

<script>
    import moment                           from 'moment';
    import { mapState }                     from 'vuex';
    import { userRoleEnum, getKeyByValue, getDataSource }  from "../../../modules/helpers";
    import { CustomerOrderGrid }            from '@/components'
    // import CustomerOrderGrid                from '../../../components/CustomerOrderGrid';
    import AdvancedCustomerSearch           from '../../../components/AdvancedCustomerSearch';
    import AdvancedOrderSearch              from '../../../components/AdvancedOrderSearch';
    import ShipToDropdown                   from '../../../components/inputComponents/ShipToDropdown';
    import {
        OrderService,
        DealerService,
        OrderPrintOptionsService,
        UserService,
        CoworkerService,
        CustomerService,
        ProductService,
        ReportService
    }                                       from '@/services';

    import { validatorMsgMapBase }          from "../../../modules/helpers.js";
    import { required }                     from 'vuelidate/lib/validators';

    // let orders = getDataSource('Orders')

    export default {
        name: "CustomerOrder",
        components: {
            CustomerOrderGrid,
            AdvancedCustomerSearch,
            AdvancedOrderSearch,
            ShipToDropdown,
        },
        data: () => {
            return {
                equipmentType: null,
                importedFile: null,
                validatorMsgMapBase: validatorMsgMapBase,
                detailView: false,
                loading: false,
                showCustomerInfo: true,
                isReadOnly: false,
                // dealerSalesTaxInfo: {},
                currentCustomer: {},
                worksheetName: '',
                installationDate: null,
                expirationDate: null,
                emptyAddress: {
                    Line1: '',
                    Line2: '',
                    City: '',
                    StateId: null,
                    PostalCode: '',
                    PhoneNumber: '',
                    FaxNumber: '',
                    Contact: '',
                    LocationCode: '',
                    AddressId: null,
                },
                billingAddress: {},
                shippingAddress: {},
                generalNotes: '',
                confidentialNotes: '',
                paymentDueOn: null,
                defaultCustomer: {
                    Id: null,
                    JdeNum: '',
                    Name: '',
                    PhoneNum: '',
                    FaxNumber: '',
                    LicenseNumber: null,
                    Specialty: null,
                    CustomerContact: {
                        FirstName: '',
                        LastName: '',
                        PhoneNumber: '',
                        Email: null,
                    },
                    Address: {
                        AddressId: 0,
                        Name: '',
                        Line1: '',
                        Line2: '',
                        City: '',
                        StateId: 10,
                        ZipCode: '',
                        Contact: '',
                        LocationCode: '',
                    },
                    IsPrivate: true
                },
                totals: {},
                creationDate: moment().format('L'),
                revisionDate: moment().format('L'),
                bundles: [{OrderLineGroupName: 'Individual Line Items', OrderLineGroupId: 0, Id: null, PrintOptionId: 4}],
                orderLines: [],
                OrderGridUpdateKey: 0,
                defaultFreightPercent: 0,
                CustomFreight: false,
                CustomDownPayment: false,
                customerJde: null,
                orderNumber: '',
                emptyTotal: {
                    id: 0,
                    subtotal: 0,
                    retail: 0,
                    freight: 0,
                    salesTax: 7,
                    isFreightPercent: true,
                    salesTaxAmount: 0,
                    total:0,
                    downPayment: 0,
                    balanceDue: 0,
                    discount: 0,
                    dealerCost: 0,
                    profit: 0,
                    actualGP: 0,
                },
                totalsSummary: [],
                //currentSavedOrder: {}
                ownerSalesRepId: null,
                // orderId: 0,
                orderStatusId: 1,
                EquipmentRepCode: null,
                AdditionalRepCode: null,
                transferredSalesRepId: null, 
                salesReps: [],
                colleagues: [],
                products: [],
                reportTypes: [],
                defaultGP: 0,
                OrderSalesSettings: {},
                printOptions: [],
                avoidRouteGuard: false,
                // orders,
                formHasBeenChanged: false,
            }
        },
        validations() {
            return {
                currentCustomer: {
                    Id: {
                        required,
                    },
                }, 
                ownerSalesRepId: {
                    required
                },
                installationDate: {
                    required
                },

            }
        },
        methods: {
            // updateDetailViewForIE11(){
            //     console.log('step 1 complete')
            // },
            getEquipmentRep(){
                console.log('code', this.colleagues, this.EquipmentRepCode)
                let index = this.colleagues.map(colleague => colleague.Code).indexOf(this.EquipmentRepCode);
                if(index < 0){
                    return {
                        Title: null,
                        Name: null,
                        FirstName: null,
                        LastName: null,
                        EmailAddress: null,
                        PhoneNumber: null,
                        Id: null,
                    }
                } else {
                    let eqrep = this.colleagues[index];
                    return{
                        Title: eqrep.Title,
                        Name: eqrep.FirstName + " " + eqrep.LastName,
                        FirstName: eqrep.FirstName,
                        LastName: eqrep.LastName,
                        EmailAddress: eqrep.Email,
                        PhoneNumber: eqrep.Phone,
                        Id: eqrep.Id,
                    }
                }
            },
            getAdditionalRep(){
                let index = this.colleagues.map(colleague => colleague.Code).indexOf(this.AdditionalRepCode);
                if(index < 0){
                    return {
                        Title: null,
                        Name: null,
                        FirstName: null,
                        LastName: null,
                        EmailAddress: null,
                        PhoneNumber: null,
                        Id: null,
                    }
                } else {
                    let addrep = this.colleagues[index];
                    return{
                        Title: addrep.Title,
                        Name: addrep.FirstName + " " + addrep.LastName,
                        FirstName: addrep.FirstName,
                        LastName: addrep.LastName,
                        EmailAddress: addrep.Email,
                        PhoneNumber: addrep.Phone,
                        Id: addrep.Id,
                    }
                }
            },
            formChanged(where){
                console.log('form changed', where)
                if(this.openRequestCount) {
                    // this isn't the best solution. The first change is due to the page loading and populating data and I want to ignore that. 
                    return;
                }
                this.formHasBeenChanged = true;
                this.avoidRouteGuard = false;
                console.log('form changed')
            },
            resetBundleTotals(){
                if(this.orderLines.length <= 0) return;
                this.totalsSummary = []
                this.bundles.forEach(bundle => {
                    this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
                })
                // this.OrderGridUpdateKey++;
            },
            addProductsFromConfigurator(newOrderLines){
                newOrderLines.forEach(line=> {
                    this.orderLines.push(line);
                })
                // this.OrderGridUpdateKey++;
            },
            addProductFromSmartCatalog(newOrderLine){
                // newOrderLine.LineNumber = this.orderLines.length;
                this.orderLines.push(newOrderLine);
            },
            importFileSelected(event){
                this.importedFile = event.target.files[0];
                console.log('imported file', event)

                OrderService.import(event.target.files[0])
                    .then(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'The file has been received and will used to import the Order.', type: 'success' });
                        this.$router.push({ name: 'CustomerOrder'})
                        this.openNewOrder() 
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'An error occurred accepting the file to import the Order.', type: 'error' });
                    })                
            },
            generateReportFinal(data){
                ReportService.generate({ReportTypeId: data.form.Id, OrderId: this.$route.params.id}).then(res => {
                    console.log('data.form', res, data.form )
                    let fileURL = window.URL.createObjectURL(new Blob([res], {type: "application/pdf"}));
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `${this.orderNumber}-${this.billingAddress.Name}-${data.form.DisplayName}.pdf`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                })
            },
            generateReport(form){
                //save order
                if(this.uncommitted && !this.isReadOnly){
                    this.saveOrder(this.generateReportFinal, {form: form});
                } else {
                    this.generateReportFinal({form: form})
                }
                
                // ReportService.generate({ReportTypeId: form.Id, OrderId: this.$route.params.id}).then(res => {
                //     console.log('form', res, form )
                //     let fileURL = window.URL.createObjectURL(new Blob([res], {type: "application/pdf"}));
                //     let fileLink = document.createElement('a');
                //     fileLink.href = fileURL;
                //     fileLink.setAttribute('download', `${this.orderNumber} ${form.DisplayName}.pdf`);
                //     document.body.appendChild(fileLink);
                //     fileLink.click();
                // }).catch(err => {
                //     this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                // })
            },
            updateOrderInfo(order){
                // this.formChanged()
                console.log('update order info', order, this.worksheetName)
                const answer = window.confirm('Are you sure you would like to leave? You may have unsaved changes!')
                if(answer){
                    this.worksheetName = order.WorksheetName;
                }
                console.log('route details', this.$route)
                if(this.$route.name === 'CustomerOrderEdit' && answer){
                    this.$router.replace({ name: 'CustomerOrderEdit', params: { id: order.Id, cid: order.CustomerId } } );
                    this.openOrder();
                } else if(this.$route.name === 'CustomerOrder' && answer){
                    this.avoidRouteGuard = true;
                    this.$router.replace({ name: 'CustomerOrderEdit', params: { id: order.Id, cid: order.CustomerId } } );
                    this.openOrder();
                }
                this.formHasBeenChanged = false;
                
            },
            saveAndCreateNewOrder(){
                this.saveOrder()
                this.createNewOrder()
            },
            cloneOrder(){
                if (!this.isReadOnly && !this.submitted) this.saveOrder()
                this.$v.currentCustomer.$touch();
                this.$v.ownerSalesRepId.$touch();
                if (this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
                    // this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }
                let order = this.setOrderStructure()
                order.SalesRepId = this.currentUser.SalesRepId;
                order.WorksheetName = "";
                OrderService.clone(order)
                    .then(res => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been duplicated', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.$router.replace({name: 'CustomerOrderEdit', params: {id: res.Id, cid: res.CustomerId}})
                        this.getCurrentOrder()
                        // this.orderId = res.Id;
                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to duplicate your order at this time', type: 'error' });
                        console.log(err)
                    })
            },
            createNewOrder(){
                if(this.$router.name !== 'CustomerOrder'){
                    this.avoidRouteGuard = true;
                    this.$router.replace({name: 'CustomerOrder'});
                }
                this.openNewOrder();
                this.toggleNewOrderModal();
            },
            openNewOrder(){
                this.worksheetName = '';
                this.installationDate =  null;
                this.expirationDate = null;
                this.generalNotes = '';
                this.confidentialNotes = '';
                this.creationDate = moment().format('L');
                this.revisionDate = moment().format('L');
                this.paymentDueOn = null;
                this.bundles = [{OrderLineGroupName: 'Individual Line Items', Id: null, OrderLineGroupId: 0, PrintOptionId: 4}];
                this.CustomFreight = false;
                this.CustomDownPayment = false;
                this.EquipmentRepCode = null;
                this.AdditionalRepCode = null;
                this.isReadOnly = false;
                this.orderNumber = ''
                this.orderStatusId = 1;
                this.transferredSalesRepId = null; 
                this.getUserSalesTaxInfo()
                this.openOrder();

            },
            submitToOrderLink(){
                OrderService.submitOrderLink([this.$route.params.id])
                    .then(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Your order has been submitted to OrderLink.', type: 'success' });
                        this.orderStatusId = 3;
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to submit order at this time to OrderLink.', type: 'error' });
                    })
            },            
            async saveAndCommitOrder(){
                this.$v.installationDate.$touch();
                this.$v.currentCustomer.$touch();
                this.$v.ownerSalesRepId.$touch();
                if (this.$v.installationDate.$invalid || this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }
                let order = this.setOrderStructure()
                OrderService.update(order)
                    .then(() => {
                        // this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.formHasBeenChanged = false;
                        this.commitOrder();
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to commit your order at this time', type: 'error' });
                    })
                    .finally(() => {
                        this.toggleCommitModal()
                    })
                // await this.saveOrder();
                
            },
            
            commitOrder(){
                OrderService.commit([this.$route.params.id])
                    .then(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Your order has been committed', type: 'success' });
                        this.orderStatusId = 2;
                        // this.isReadOnly = true;
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to commit order at this time', type: 'error' });
                    })
            },
            updateCustomerInfo(){
                this.formChanged('updateCusotmerInfo')
                // if(this.$route.params.id){
                    // this.avoidRouteGuard = true;
                    this.$router.replace({ params: {cid: this.currentCustomer.Id}});
                this.getCurrentCustomerBandaid(this.currentCustomer.Id)
                // this.updateBillingShippingInfo()
            },
            bundleWithSubtotalIncluded(){
                let newBundles = []
                this.bundles.forEach(bundle => {
                    let index = this.totalsSummary.map(total => total.id).indexOf(bundle.OrderLineGroupId);
                    newBundles.push({
                        ...bundle,
                        Subtotal: this.totalsSummary[index].subtotal
                    })
                })
                return newBundles;
            },
            setOrderStructure(){
                let eqRep = this.getEquipmentRep();
                let addRep = this.getAdditionalRep();
                console.log('reps', eqRep, addRep)
                let res = {
                    Id: this.$route.params.id || null,
                    JdeNumber: this.currentCustomer.JdeNum,
                    CustomerName: this.currentCustomer.Name,
                    CustomerId: this.currentCustomer.Id,
                    OrderStatusId: this.orderStatusId,
                    DealerId: this.currentUser.DealerId,
                    Status: null,
                    Bundles: this.bundleWithSubtotalIncluded(),
                    CreatedOn: moment(this.creationDate).format('L'),
                    RevisedOn: moment(this.revisionDate).format('L'),
                    InstalledOn: moment(this.installationDate).format('L'),
                    ExpiresOn: moment(this.expirationDate).format('L'),
                    BillingInfo: this.billingAddress,
                    ShippingInfo: this.shippingAddress,
                    SalesRepId: this.ownerSalesRepId,
                    EquipmentRepCode: this.EquipmentRepCode,
                    EquipmentRepTitle: eqRep.Title,
                    EquipmentRepName: eqRep.Name,
                    EquipmentRepFirstName: eqRep.FirstName,
                    EquipmentRepLastName: eqRep.LastName,
                    EquipmentRepEmailAddress: eqRep.Email,
                    EquipmentRepPhoneNumber: eqRep.Phone,
                    EquipmentRepId: eqRep.Id,
                    AdditionalRepCode: this.AdditionalRepCode,
                    AdditionalRepTitle: addRep.Title,
                    AdditionalRepName: addRep.Name,
                    AdditionalRepFirstName: addRep.FirstName,
                    AdditionalRepLastName: addRep.LastName,
                    AdditionalRepEmailAddress: addRep.Email,
                    AdditionalRepPhoneNumber: addRep.Phone,
                    AdditionalRepId: addRep.Id,
                    TransferredFromRepId: null,
                    PaymentDueOn: moment(this.paymentDueOn).format('L'),
                    GeneralNotes: this.generalNotes,
                    ConfidentialNotes: this.confidentialNotes,
                    OrderLines: this.orderLines,
                    SalesTax: this.totals.salesTaxAmount,
                    SalesTaxRate: this.totals.salesTax,
                    Freight: this.totals.freight,
                    FreightPercentage: this.CustomFreight ? null : this.defaultFreightPercent,
                    DownPayment: this.totals.downPayment,
                    SubTotal: this.totals.subtotal,
                    Total: this.totals.total,  
                    BalanceDue: this.totals.balanceDue,
                    Discount: this.totals.discount,
                    DealerCost: this.totals.dealerCost,
                    DiscountPercentage: this.totals.discountPercent,
                    Profit: this.totals.profit,
                    CustomDownPayment: this.CustomDownPayment,
                    CustomFreight: this.CustomFreight,
                    OrderSalesSettings: this.OrderSalesSettings,
                    WorksheetName: this.worksheetName,
                }
                return res;
            },

            

            saveOrder(callback = null, callbackParams = {}){
                console.log('saveOrderCallback', typeof(callback))
                if(typeof(callback) !== 'function'){
                    callback = null;
                }
                this.$v.currentCustomer.$touch();
                this.$v.ownerSalesRepId.$touch();
                if (this.$v.currentCustomer.$invalid || this.$v.ownerSalesRepId.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }
                let order = this.setOrderStructure()
                console.log('order', order)
                // if ((this.$route.params !== null) && (this.$route.params !== undefined))
                if(order.Id === null){
                    this.saveNewOrder(order, callback, callbackParams)
                } else {
                    this.updateOrder(order, callback, callbackParams)
                }
                this.formHasBeenChanged = false;
                // this.getCurrentOrder();
                
            },
            saveNewOrder(order, callback = null, callbackParams = {}){
                OrderService.create(order)
                    .then(res => {
                        console.log(('response from order save', res))
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.orderNumber = res.OrderNumber;
                        this.$router.replace({name: 'CustomerOrderEdit', params: {id: res.Id, cid: res.CustomerId}})
                        // this.orderId = res.Id;
                        if(callback){
                            callback(callbackParams);
                        }
                        

                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to save your order at this time', type: 'error' });
                        console.log(err)
                    })
            },
            updateOrder(order, callback = null, callbackParams = {}){
                OrderService.update(order)
                    .then(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'Order has been saved', type: 'success' });
                        this.avoidRouteGuard = true;
                        this.formHasBeenChanged = false;
                        console.log('in update', callback, callbackParams)
                        if(callback){
                            console.log('trying to callback', callback, callbackParams)
                            callback(callbackParams);
                        }
                        
                    })
                    .catch(() => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: 'We were unable to save your order at this time', type: 'error' });
                    })
            },
            updateTotalsValues(tot, groupId){
                // this.formChanged('updateTotalsValues')
                let totalsIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                this.totalsSummary[totalsIndex] = this.copy(tot)
                this.setTotals()
            },
            updateOrderLines(lineNumber, bundleId){
                // this.updateLineIds()
                let orderLineIndex = this.orderLines.map(line => line.LineNumber).indexOf(lineNumber);
                let bundleIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(bundleId);
                this.orderLines[orderLineIndex].OrderLineGroupName = this.bundles[bundleIndex].OrderLineGroupName;
                this.updateOrderLineNumbers();
                this.reloadOrderLines();
            },
            updateOrderLineNumbers(){
                let number = 0;
                let reorderedLines = []
                this.bundles.forEach(bundle => {
                    
                    this.orderLines.forEach(line => {
                        if(line.OrderLineGroupId === bundle.OrderLineGroupId){
                            line.LineNumber = number;
                            reorderedLines.push(line)
                            number++;
                        }
                    })
                })
                this.orderLines = reorderedLines
            },
            copyOrderLines(orderLinesAdded){
                orderLinesAdded.forEach(line => {
                    line.OrderLineId = null
                    this.orderLines.push(line)
                })
                this.updateOrderLineNumbers()

                //api
            },
            reloadOrderLines(){
                this.OrderGridUpdateKey += 1;
            },
            toggleDeleteModal(){
                this.$refs.deleteOrderModal.toggle();
            },
            toggleCommitModal(){
                this.$refs.commitOrderModal.toggle();
            },
            toggleNewOrderModal(){
                this.$refs.newOrderModal.toggle();
            },
            newOrderHasBeenRequested(){
                console.log('new order has been requested', this.avoidRouteGuard, !this.formHasBeenChanged)
                if(this.avoidRouteGuard || !this.formHasBeenChanged){
                    if(this.$router.name !== 'CustomerOrder'){
                        this.avoidRouteGuard = true;
                        this.$router.replace({name: 'CustomerOrder'});
                    }
                    this.openNewOrder();
                } else {
                    this.toggleNewOrderModal()
                }
            },
            deleteOrder(){
                if(!this.uncommitted){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Orders that are ${this.orderStatus} may not be deleted.` , type: 'error' });
                    return;
                }
                OrderService.delete({id: this.$route.params.id})
                    .then((res) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been deleted" , type: 'success' });
                        this.$router.replace({ name: 'CustomerOrder'})
                        this.openNewOrder() 
                    })
                    .catch((err) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                    })
                this.toggleDeleteModal();
        
            },
            toggleUncommitModal(){
                this.$refs.uncommitOrderModal.toggle();
            },
            // toggleRouteGuardModal(){
            //     this.$refs.routeGuardModal.toggle();
            // },
            uncommitOrder(){
                if(!this.committed){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: `Orders that are ${this.orderStatus} may not be uncommitted.` , type: 'error' });
                    return;
                }

                OrderService.uncommit([this.$route.params.id])
                    .then((res) => {
                        this.orderStatusId = 1;
                        this.$store.dispatch('ADD_NOTIFICATION', { text: "Order has been uncommitted" , type: 'success' });
                        this.saveOrder()
                    })
                    .catch((err) => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                    })
                this.toggleUncommitModal();      
            },     
            editBundle(bundle){
                let bundleIndex = this.bundles.map(b => b.OrderLineGroupId).indexOf(bundle.OrderLineGroupId)
                this.bundles[bundleIndex] = bundle;
                this.orderLines.forEach(line => {
                    if(line.OrderLineGroupId === bundle.OrderLineGroupId){
                        line.OrderLineGroupName = bundle.OrderLineGroupName;
                        line.PrintOptionId = bundle.PrintOptionId;
                    }
                })
                this.reloadOrderLines()
            },      
            createNewBundle(title, printOptionId){
                let newId = 0;
                this.bundles.forEach(group => {
                    if(group.OrderLineGroupId >= newId){
                        newId = group.OrderLineGroupId + 1;
                    }
                })
                this.bundles.push({OrderLineGroupName: title, OrderLineGroupId: newId, Id: null, PrintOptionId: printOptionId})
                this.orderLines.forEach(line => {
                    if(line.OrderLineGroupId === -1) line.OrderLineGroupId = newId
                })
                this.totalsSummary.push({...this.emptyTotal, id: newId})
                this.reloadOrderLines()
            },
            deleteBundle(groupId){
                let groupIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                let totalsIndex = this.totalsSummary.map(totals => totals.id).indexOf(groupId)
                this.bundles.splice(groupIndex, 1)
                this.totalsSummary.splice(totalsIndex, 1)
                let linesToDelete = [];
                this.orderLines.forEach((line, index) => {
                    if(line.OrderLineGroupId === groupId){
                        linesToDelete.push(line.LineNumber)
                        // this.orderLines.splice(index, 1)
                    }
                })
                linesToDelete.sort(function(a,b){ return b - a; })
                for (var i = linesToDelete.length -1; i >= 0; i--){
                    let index = this.orderLines.map(line => line.LineNumber).indexOf(linesToDelete[i])
                    this.orderLines.splice(index,1);
                }
                this.setTotals()
            },
            deleteBundleAndKeepOrderLines(groupId){
                let groupIndex = this.bundles.map(group => group.OrderLineGroupId).indexOf(groupId)
                let totalsIndex = this.totalsSummary.map(totals => totals.id).indexOf(groupId)
                this.bundles.splice(groupIndex, 1)
                this.totalsSummary.splice(totalsIndex, 1)
                this.orderLines.forEach((line, index) => {
                    if(line.OrderLineGroupId === groupId){
                        line.OrderLineGroupId = 0;
                    }
                })
                this.OrderGridUpdateKey++;
            },
            freightChanged(){
                this.CustomFreight = true;
                this.setTotals();
            },
            downPaymentChanged(){
                this.CustomDownPayment = true;
                this.setTotals();
            },
            setTotals(){
                // const keys = Object.keys(this.totals)
                this.totals.subtotal = 0;
                this.totals.retail = 0;
                this.totals.dealerCost = 0;
                this.totalsSummary.forEach(total => {
                    this.totals.subtotal += total.subtotal;
                    this.totals.retail += total.retail;
                    this.totals.dealerCost += total.dealerCost;
                })
                // if(this.totals.subtotal === 0){
                //     console.log('a')
                //     this.totals.freight = 0;
                // } else 
                if(this.totals.isFreightPercent && !this.CustomFreight){
                    this.totals.freight = this.round((this.totals.subtotal * this.defaultFreightPercent/100));
                } else if(this.CustomFreight){
                    this.totals.freight = this.round(this.totals.freight);
                } else {
                    this.totals.freight = this.round(this.defaultFreightAmount);
                } 
                let subtotalWithFreight             = this.OrderSalesSettings.TaxFreight ? this.totals.subtotal + this.totals.freight : this.totals.subtotal;
                this.totals.salesTaxAmount          = this.round((((subtotalWithFreight) * this.totals.salesTax)/100));
                this.totals.total                   = this.totals.subtotal + this.totals.freight + this.totals.salesTaxAmount;
                this.totals.downPayment             = this.CustomDownPayment ? this.round(this.totals.downPayment) : this.round(this.totals.total / 10);
                this.totals.balanceDue              = this.totals.total - this.totals.downPayment;
                this.totals.discountPercent         = this.roundToTwoDecimals(((this.totals.retail - this.totals.subtotal) / this.totals.subtotal) * 100)
                this.totals.discount                = this.totals.retail - this.totals.subtotal;
                this.totals.profit                  = this.totals.retail - this.totals.dealerCost - this.totals.discount;
                this.totals.actualGP                = this.roundToTwoDecimals(((this.totals.subtotal - this.totals.dealerCost) / this.totals.subtotal) * 100);
                // if(this.totals.total === 0){
                //     this.totals.freight = 0;
                // } else if(this.totals.isFreightPercent && !this.CustomFreight){
                //     this.totals.freight = this.round((this.totals.subtotal * this.defaultFreightPercent/100));
                // } else if(this.CustomFreight){
                //     this.totals.freight = this.round(this.totals.freight);
                // } else {
                //     this.totals.freight = this.round(this.defaultFreightAmount);
                // }   
                this.setTotalsTwoDecimal()
            },
            roundToTwoDecimals(data){
                if(Number(data) === 'NaN') return;
                return Math.round(data * 100) / 100;
            },
            round(data){
                if(Number(data) === 'NaN') return;
                return this.OrderSalesSettings.RoundToNearestDollar ? Math.round(data) : this.roundToTwoDecimals(data);
            },
            setTotalsTwoDecimal(){
                const keys = Object.keys(this.totals)
                keys.forEach(key => {
                    if(key === 'isFreightPercent') return;
                    if(this.totals[key] === null) return;
                    this.totals[key] = this.totalShouldBeRoundedToNearestDollar(key) ? Number(this.totals[key].toFixed(0)) : Number(this.totals[key].toFixed(2)); 
                })
            },
            totalShouldBeRoundedToNearestDollar(key){
                return this.OrderSalesSettings.RoundToNearestDollar && key !== 'actualGP' && key !== 'discountPercent'
            },
            updateShippingInfo(shippingId){
                if(shippingId){
                    let index = this.currentCustomer.Addresses.map(address => address.AddressId).indexOf(shippingId);
                    this.shippingAddress = {
                        ...this.emptyAddress,
                        ...this.currentCustomer.Addresses[index],
                        LastUsedCustomerAddressId: this.currentCustomer.Addresses[index].AddressId
                        //maybe add contact info here
                    }
                }
                else{
                    this.shippingAddress = {
                        ...this.emptyAddress,
                        LastUsedCustomerAddressId: null
                        //maybe add contact info here
                    }
                }
                
            },
            updateBillingShippingInfo(){
                let customerContact = {};
                if(this.currentCustomer.CustomerContact){
                    customerContact = {
                        PhoneNumber: this.currentCustomer.CustomerContact.PhoneNumber,
                        Contact: this.currentCustomer.CustomerContact.FirstName + " " + this.currentCustomer.CustomerContact.LastName, 
                        Name: this.currentCustomer.Name
                    };
                } else {
                    customerContact = { PhoneNumber: '', Contact: '', Name: ''};
                }
                let address = {...this.emptyAddress}
                if(this.currentCustomer.Addresses[0]){
                    address = {...this.currentCustomer.Addresses[0]}
                }
                this.billingAddress = {
                    ...address,
                    ...customerContact,

                    Name: this.currentCustomer.Name
                }
                this.shippingAddress = {...this.billingAddress, LastUsedCustomerAddressId: address.AddressId}
            },
            getUserSalesTaxInfo(){
                UserService.salesTax(this.currentUser.SalesRepId)
                    .then(res => {
                    // this.dealerSalesTaxInfo = { ...res };
                        this.OrderSalesSettings = res;
                        // this.OrderSalesSettings.RoundToNearestDollar = res.RoundToNearestDollar
                        this.totals.isFreightPercent = res.IsDefaultFreightPercent; 
                        this.defaultFreightPercent = res.IsDefaultFreightPercent ? res.DefaultFreight : null;
                        this.defaultFreightAmount = res.IsDefaultFreightPercent ? null : res.DefaultFreight;
                        this.defaultGP = res.GPPercent;
                        //below will be obsolete when OrderSalesSettings is getting passed back in order get.
                        if(!this.$route.params.id){
                            this.totals.salesTax = res.SalesTax;
                            // this.totals.freight = res.IsDefaultFreightPercent ? 0 : res.DefaultFreight;
                        }
                        
                    })
                    .catch(err => {
                    console.log(err)
                    })
                
            },
            copy(obj){
                return JSON.parse(JSON.stringify(obj))
            },
            // setBundles( ){
            //     // I will need to remove this and set the bundles on get order.
            //     if(this.orderLines.length <= 0) return;
            //     this.bundles = []
            //     this.totalsSummary = []
            //     this.orderLines.forEach(line => {
            //         let index = this.bundles.map(bundle => bundle.OrderLineGroupId).indexOf(line.OrderLineGroupId)
            //         if(index < 0) {
            //             this.bundles.push({
            //                 OrderLineGroupName: line.OrderLineGroupName,
            //                 OrderLineGroupId: line.OrderLineGroupId,
            //             })
            //             this.totalsSummary.push({...this.emptyTotal, id: line.OrderLineGroupId})
            //         }
            //     })
            //     this.OrderGridUpdateKey++;
            // },
            resetBundleTotals(){
                if(this.orderLines.length <= 0) return;
                this.totalsSummary = []
                this.bundles.forEach(bundle => {
                    this.totalsSummary.push({...this.emptyTotal, id: bundle.OrderLineGroupId})
                })
                // this.OrderGridUpdateKey++;
            },
            getCurrentCustomer(id){
                if(!id) {
                    this.getCustomerByJde();
                    return;
                }
                CustomerService.get({id: id})
                    .then((res) => {
                        this.currentCustomer = res
                        if (!this.$route.params.id) this.updateBillingShippingInfo();
                    })
                    .catch(err => {
                        // this.getCustomerByJde();
                        console.log(err)
                    })
                
            },
            getCurrentCustomerBandaid(id){
                if(!id) {
                    this.getCustomerByJde();
                    return;
                }
                CustomerService.get({id: id})
                    .then((res) => {
                        this.currentCustomer = res
                        this.updateBillingShippingInfo();
                    })
                    .catch(err => {
                        // this.getCustomerByJde();
                        console.log(err)
                    })
                
            },
            getCustomerByJde(){
                CustomerService.jde(this.customerJde)
                    .then(res => {
                        this.currentCustomer = res;
                        if (!this.$route.params.id) this.updateBillingShippingInfo();
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            getCurrentOrder(){
                if(this.$route.params.id){
                    OrderService.get({id: this.$route.params.id})
                        .then(res => {
                            console.log('getOrder res ==>', res)
                            this.customerJde = res.JdeNumber;
                            this.getCurrentCustomer(res.CustomerId)
                            // this.orderId = this.$route.params.id; 
                            this.orderNumber = res.OrderNumber
                            this.OrderSalesSettings = res.OrderSalesSettings;
                            this.defaultGP = res.OrderSalesSettings.GPPercent;
                            this.defaultFreightPercent = res.OrderSalesSettings.IsDefaultFreightPercent ? res.OrderSalesSettings.DefaultFreight : null;
                            this.defaultFreightAmount = res.OrderSalesSettings.IsDefaultFreightPercent ? null : res.OrderSalesSettings.DefaultFreight;
                            // this.currentCustomer.Id = res.CustomerId;
                            this.orderStatusId = res.OrderStatusId;
                            this.worksheetName = res.WorksheetName;
                            // May need to confirm this.currentUser.DealerId == res.DealerId; 
                            // this.?? = res.Status;

                            this.creationDate = moment(res.CreatedOn).format('L'),
                            this.revisionDate = moment(res.RevisedOn).format('L');
                            this.installationDate = res.InstalledOn;
                            this.expirationDate = res.ExpiresOn;

                            this.paymentDueOn = res.PaymentDueOn;
                            this.billingAddress = res.BillingInfo;
                            this.shippingAddress = res.ShippingInfo;
                            this.orderLines = res.OrderLines;
                            //this.setBundles();
                            // replace above with below
                            this.bundles = res.Bundles;
                            this.resetBundleTotals();
                            this.generalNotes = res.GeneralNotes;
                            this.confidentialNotes = res.ConfidentialNotes;

                            this.totals.salesTaxAmount = res.SalesTax;
                            this.totals.salesTax = res.SalesTaxRate;
                            this.totals.downPayment = res.DownPayment;
                            this.totals.subtotal = res.SubTotal;
                            this.totals.total = res.Total;  
                            this.totals.balanceDue = res.BalanceDue;
                            this.totals.discount = res.Discount;
                            this.totals.dealerCost = res.DealerCost;
                            this.totals.discountPercent = res.DiscountPercentage;
                            this.totals.profit = res.Profit;
                            this.totals.isFreightPercent = res.OrderSalesSettings.IsDefaultFreightPercent;
                            this.CustomDownPayment = res.CustomDownPayment;
                            this.CustomFreight = res.CustomFreight;
                            if(res.Subtotal === 0){
                                console.log('0')
                                this.totals.freight = 0;
                            } else if(res.CustomFreight){
                                console.log('1')
                                this.totals.freight = res.Freight;
                            } else {
                                console.log('2')
                                this.totals.freight = this.defaultFreightAmount;
                            }
                            // this.totals.freight = res.CustomFreight ? res.Freight : this.defaultFreightAmount;
                            
                            
                            this.ownerSalesRepId = res.SalesRepId;
                            this.EquipmentRepCode = res.EquipmentRepCode;
                            this.AdditionalRepCode = res.AdditionalRepCode;
                            this.transferredSalesRepId = res.TransferredFromRepId;
                            this.isReadOnly = res.IsOrderReadOnly;

                        })
                        .catch(err => {
                            console.log(err)
                        })
                        .finally(() => {
                            // this.setTotals();
                            this.OrderGridUpdateKey++;
                            this.resetRouteGuardCheck()
                        })                        
                } else {
                    if(this.$route.params.cid){
                        this.getCurrentCustomer(this.$route.params.cid);
                    }else{
                        this.currentCustomer = this.defaultCustomer;
                    }
                    // this.orderId = null;
                    this.ownerSalesRepId = this.currentUser.SalesRepId;
                }
                
            },
            getSalesReps(){
                let dealerId = this.currentUser.DealerId;
                DealerService.transferSalesReps(dealerId).then(res => {
                    this.salesReps = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            getColleagues(){
                CoworkerService.all().then(res => {
                    this.colleagues = res.data;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            getProducts(){
                ProductService.all().then(res => {
                    this.products = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                })
            },
            getReportTypes(){
                ReportService.types().then(res => {
                    this.reportTypes = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            getOrderPrintOptions(){
                OrderPrintOptionsService.all()
                .then(res => {
                    this.printOptions = res
                }) .catch(err => {
                    console.log(err)
                }).finally(() => {
                    this.resetRouteGuardCheck()
                })
            },
            // getOrders(){
            //     this.loading = true
            //     OrderService.all().then(response => {
            //         this.orders = response;
            //     }).catch(err => {
            //         console.log(err)
            //     }).finally(() => {
            //         this.loading = false 
            //     })
            // },
           openOrder(){
                
                this.loading = true;
                this.totals = {...this.emptyTotal};
                this.orderLines = [];
                this.billingAddress = this.emptyAddress;
                this.shippingAddress = this.emptyAddress;
                this.totalsSummary=[{...this.emptyTotal}];
                // this.currentCustomer = this.defaultCustomer; // this will need to be changed when we import a customer from the customer search/order search page
                this.getCurrentOrder()
                // this.updateBillingShippingInfo() 
                this.getSalesReps()
                this.getColleagues() 
                // this.getProducts();
                this.getOrderPrintOptions()
                this.getReportTypes();
                // await this.getOrders();
                this.formHasBeenChanged = false;
                this.avoidRouteGuard = true;
                this.loading = false; 
            },
            resetRouteGuardCheck(){
                this.formHasBeenChanged = false;
                this.avoidRouteGuard = true;
            }
        },

            // watch: {
            //     detailView: function(){
            //         this.updateDetailViewForIE11();
            //     }
            // },
        computed: {
            ...mapState(['currentUser', 'openRequestCount']),
            currentUserSalesAdminOrMgr(){
                let currentUserRole = getKeyByValue(userRoleEnum, this.currentUser.UserRoleId);
                return (['Sales Administrator', 'Sales Manager'].includes(currentUserRole));
            },
            orderHasId(){
                return this.$route.params.id;
            },
            transferredRep(){
                let index = this.salesReps.map(rep => rep.SalesRepId).indexOf(this.transferredSalesRepId)
                if(index >= 0){
                   return this.salesReps[index].FirstName + " " + this.salesReps[index].LastName; 
                } else {
                    return ""
                } 
            },
            committed(){
                return this.orderStatus === "Committed"
            },
            uncommitted(){
                return this.orderStatus === "Uncommitted"
            },
            submitted(){
                return this.orderStatus === "Submitted"
            },
            orderStatus(){
                switch(this.orderStatusId) {
                    case 1:
                        return "Uncommitted"
                        break;
                    case 2:
                        return "Committed"
                        break;
                    case 3:
                        return "Submitted"
                        break;
                    default:
                        return "Lost in Space"
                    }
            }
        },
        // beforeRouteUpdate(to, from, next) {
        //     console.log('beforeRouteUpdate: HOME')
        //     next()
        // },
        beforeRouteLeave(to, from, next) {
            console.log('route guard',)
            const answer = this.avoidRouteGuard || !this.formHasBeenChanged || to.name === 'Login'? 
                true : 
                window.confirm('Are you sure you would like to leave this page? You may have unsaved changes!');
            if (answer) {
                next()
            } else {
                next(false)
            }
            this.avoidRouteGuard = false;
            
        },
        async created(){
            console.log('created')
            this.$route.params.id ?
            this.openOrder() :
            this.openNewOrder();
            
        },
    }
</script>

<style scoped lang="scss">
    .form-item{
        white-space: nowrap;
    }
    .customer-order-wrapper{
        // max-width: 1800px;
    }
    .customer-order-header{
        margin-bottom: -20px;
    }
    .header-order-id{
        color: $primary;
        font-size: 16px;
        float: right;
    }
    .modal-wrapper{
        width: 400px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .btn-wrapper{
            margin-top: 25px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn{
                min-width: 125px;
            }
            &.center{
                justify-content: space-around;
                align-items: center;
            }
        }
    }
    .Uncommitted{
        color: $warning;
    }
    .Committed{
        color: $success;
    }
    .Submitted{
        color: $error;
    }
    .top-level-order-btns {
        width: 100%;
        font-size: .9em;
        .btn {
            font-size: .9em;
            min-width: 110px;
            margin: 3px 0;
        }
    }
    .worksheet-input{
        font-size: 1.5em;
        color: $ss-grey;
        border: none;
        border-bottom: 1px solid $secondary; 
        margin-left: 20px;
        margin-bottom: 25px;
    }

    .lower-level-order-btns__right {
        display: flex;
        justify-content: space-around;
        margin-bottom: 50px;
        .btn {
            min-width: 135px;
            margin: 3px 0;
        }
    }

    .date-display {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 100%;

        &__wrapper {
            display: flex;
            flex-direction: column;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        }
        &__title {
            font-weight: bolder;
        }
        &__value {
            font-style: italic;
        }
    }
    .customer-info-header-wrapper{
        display: flex;
        justify-content: space-between;
        .show-details-toggle{
            cursor: pointer;
            margin-bottom: 0px;
        }
    }
    .grid-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .lower-section {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-column-gap: 25px;
        grid-row-gap: 25px;
        .hide-confidential{
            grid-column-start: 1;
            grid-column-end: 3  ;
            grid-row-start: 2;
            grid-row-end: 2
        }
        .summary {
            grid-column-start: 3;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-row-end: 3
        }
    }
    .dropdown-menu {
        padding: 10px;
        background-color: $black-050;
        border: solid 1px $secondary;
        border-radius: 4px;
        box-shadow: $box-shadow;
    }
    .dropdown-toggle {
        margin: -20px;
    }


    /* The switch - the box around the slider */
    .switch {
        transform: scale(0.75);
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $ss-grey2;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: $primary;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px $primary;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
    .modal-text{
        text-align: center;
        margin-top: 10px;
        margin-bottom: 0px;
    }
</style>
